<template>
  <section class="partners-section" :aria-label="$t('partnersSlider.ariaLabel')">
<div class="partners-header">
  <h1 class="gradient-text2 medium-h1">{{ $t('partnersSlider.eyebrow') }}</h1>
  <h2>{{ $t('partnersSlider.title') }}</h2>
</div>

<div class="partners-marquee">
  <div class="partners-track">
    <div
      v-for="(partner, index) in partners.concat(partners)"
      :key="`${partner.name}-${index}`"
      class="partner-card"
    >
      <img
        :src="partner.logo"
        :alt="partner.name"
        :loading="index < partners.length ? 'eager' : 'lazy'"
        decoding="async"
      />
    </div>
  </div>
</div>
  </section>
</template>

<script>
import logoAsglacon from '@/assets/logo_partners/AsGlacons.svg';
import logoColicoli from '@/assets/logo_partners/Colicoli.svg';
import logoCoventry from '@/assets/logo_partners/CoventrySchool.svg';
import logoGlowroom from '@/assets/logo_partners/GlowRoom.svg';
import logoJo from '@/assets/logo_partners/BurgersRichard.svg';
import logoKichui from '@/assets/logo_partners/Kichui.svg';
import logoMeyou from '@/assets/logo_partners/MeYou.svg';
import logoOmegahealth from '@/assets/logo_partners/OmegaHealth.svg';
import logoSelia from '@/assets/logo_partners/Selia.svg';
import logoSolutionalarme from '@/assets/logo_partners/SolutionAlarm.svg';
import logoTechvisor from '@/assets/logo_partners/Techvisor.svg';
import logoVolteos from '@/assets/logo_partners/Volteos.svg';
import logoAssoibnbaytar from '@/assets/logo_partners/Albaytar.svg';
import logoDeastylHome from '@/assets/logo_partners/Deastyl.svg';
import logoMnDrive from '@/assets/logo_partners/MNDrive.svg';
import logoMoroccantailor from '@/assets/logo_partners/MoroccanTailor.svg';
import logoSeaOfSounds from '@/assets/logo_partners/SeaOfSounds.svg';
import logoShowAllReviews from '@/assets/logo_partners/ShowAllReviews.svg';
import logoSmartPhysio from '@/assets/logo_partners/SmartPhysio.svg';
import logoSushiPoke from '@/assets/logo_partners/Sushi_poke.svg';
import logoWelco from '@/assets/logo_partners/Welco.svg';
import logoDevisly from '@/assets/logo_partners/Devisly.svg';
import logoGrinta from '@/assets/logo_partners/Grinta.svg';
import logoOnway from '@/assets/logo_partners/Onway.svg';
import logoProximy from '@/assets/logo_partners/Proximy.svg';
import logoWelkomParis from '@/assets/logo_partners/WelkomParis.svg';


export default {
  name: 'PartnersSlider',
  data() {
return {
  partners: [
    { name: 'Asglacon', logo: logoAsglacon },
    { name: 'Colicoli', logo: logoColicoli },
    { name: 'Coventry', logo: logoCoventry },
    { name: 'Glowroom', logo: logoGlowroom },
    { name: 'Jo', logo: logoJo },
    { name: 'Kichui', logo: logoKichui },
    { name: 'Meyou', logo: logoMeyou },
    { name: 'Omegahealth', logo: logoOmegahealth },
    { name: 'Selia', logo: logoSelia },
    { name: 'Solution Alarm', logo: logoSolutionalarme },
    { name: 'Techvisor', logo: logoTechvisor },
    { name: 'Volteos', logo: logoVolteos },
    { name: 'Assoibnbaytar', logo: logoAssoibnbaytar },
    { name: 'Show All Reviews', logo: logoShowAllReviews },
    { name: 'Deastyl Home', logo: logoDeastylHome },
    { name: 'Mn Drive', logo: logoMnDrive },
    { name: 'Moroccan Tailor', logo: logoMoroccantailor },
    { name: 'Sea Of Sounds', logo: logoSeaOfSounds },
    { name: 'Smart Physio', logo: logoSmartPhysio },
    { name: 'Sushi Poke', logo: logoSushiPoke },
    { name: 'Welco', logo: logoWelco },
    { name: 'Devisly', logo: logoDevisly },
    { name: 'Grinta', logo: logoGrinta },
    { name: 'Onway', logo: logoOnway },
    { name: 'Proximy', logo: logoProximy },
    { name: 'Welkom Paris', logo: logoWelkomParis },
  ],
};
  },
};
</script>

<style scoped>
.partners-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.partners-header {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  text-align: center;
}

.partners-eyebrow {
  margin: 0;
  color: #7b8cff;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.24em;
  text-transform: uppercase;
}

.partners-title {
  margin: 0;
  color: #f9f9f9;
  font-size: clamp(1.5rem, 2vw + 1rem, 2.25rem);
  font-weight: 600;
}

.partners-marquee {
  overflow: hidden;
  mask-image: linear-gradient(90deg, transparent 0%, #000 10%, #000 90%, transparent 100%);
  -webkit-mask-image: linear-gradient(90deg, transparent 0%, #000 10%, #000 90%, transparent 100%);
}

.partners-track {
  display: flex;
  width: max-content;
  gap: 2rem;
  animation: scrollPartners 24s linear infinite;
  will-change: transform;
}

.partner-card {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  min-height: 74px;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  backdrop-filter: none;
  box-shadow: none;
}

.partner-card img {
  display: block;
  height: 74px;
  width: auto;
  max-width: 180px;
  object-fit: contain;
  filter: grayscale(1) brightness(1.05);
  opacity: 0.95;
}

.partners-marquee:hover .partners-track {
  animation-play-state: paused;
}

@keyframes scrollPartners {
  from {
transform: translateX(0);
  }
  to {
transform: translateX(-50%);
  }
}

@media (max-width: 768px) {
  .partners-section {
gap: 1.25rem;
margin-top: 1rem;
  }

  .partner-card {
min-width: 150px;
min-height: 56px;
 }

  .partners-track {
gap: 1.4rem;
  }

  .partner-card img {
height: 56px;
max-width: 140px;
  }
}
</style>
